import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Development-only mock for OTP send API
if (process.env.NODE_ENV === 'development') {
  const originalFetch = window.fetch.bind(window);
  const matchesOtpSend = (url) => {
    try {
      const u = new URL(url, window.location.origin);
      return u.pathname === '/api/otp/send';
    } catch (e) {
      return url === '/api/otp/send';
    }
  };
  const matchesOtpVerify = (url) => {
    try {
      const u = new URL(url, window.location.origin);
      return u.pathname === '/api/otp/verify';
    } catch (e) {
      return url === '/api/otp/verify';
    }
  };
  window.fetch = async (input, init) => {
    const url = typeof input === 'string' ? input : input.url;
    if (matchesOtpSend(url)) {
      return new Response(
        JSON.stringify({ success: true, message: 'Mock OTP sent', otp: '123456' }),
        { status: 200, headers: { 'Content-Type': 'application/json' } }
      );
    }
    if (matchesOtpVerify(url)) {
      // Accept only OTP "123456"
      let bodyText = '';
      try {
        if (typeof input !== 'string' && input && typeof input.clone === 'function') {
          bodyText = await input.clone().text();
        } else if (init && typeof init.body === 'string') {
          bodyText = init.body;
        }
        const data = bodyText ? JSON.parse(bodyText) : {};
        if (data && data.otp === '123456') {
          return new Response(
            JSON.stringify({ success: true, message: 'OTP verified' }),
            { status: 200, headers: { 'Content-Type': 'application/json' } }
          );
        }
      } catch (e) {
        // fall through to failure
      }
      return new Response(
        JSON.stringify({ success: false, message: 'Invalid OTP' }),
        { status: 400, headers: { 'Content-Type': 'application/json' } }
      );
    }
    return originalFetch(input, init);
  };
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
